// Tipos de cliente da tela de Clientes (regra única no backend:
// api/v1/clientes/segments.py). Usados no "Para quem vale" de Cupom, Promoção e
// Cashback e no botão de ofertas dos cards de Clientes (dono, 27/10/2026).
// Lista vazia = vale para todos.
export const TIPOS_CLIENTE = {
  vip: { nome: "Cliente VIP", curto: "VIP", regra: "mais de 4 pedidos em 30 dias" },
  recorrente: { nome: "Recorrente", curto: "Recorrentes", regra: "3 ou 4 pedidos em 30 dias" },
  novo: { nome: "Novo", curto: "Novos", regra: "cadastrado, ainda sem pedido" },
  primeiro_pedido: { nome: "1º Pedido", curto: "1º Pedido", regra: "comprou 1 vez" },
  em_risco: { nome: "Em Risco", curto: "Em Risco", regra: "30 a 60 dias sem comprar" },
  perdido: { nome: "Perdido", curto: "Perdidos", regra: "mais de 60 dias sem comprar" },
  ativo: { nome: "Ativo", curto: "Ativos", regra: "os demais clientes" },
};
export const ORDEM_TIPOS = Object.keys(TIPOS_CLIENTE);

/** Só chaves válidas, na ordem da tela. */
export const limparTipos = (lista) => ORDEM_TIPOS.filter((k) => (lista || []).includes(k));

/** "Recorrente e Cliente VIP"; vazio → "Todos os clientes". `campo: "curto"` → "VIP e Recorrentes". */
export function nomesTipos(lista, vazio = "Todos os clientes", campo = "nome") {
  const nomes = limparTipos(lista).map((k) => TIPOS_CLIENTE[k][campo]);
  if (!nomes.length) return vazio;
  return nomes.length === 1 ? nomes[0] : `${nomes.slice(0, -1).join(", ")} e ${nomes[nomes.length - 1]}`;
}

/** Filtro das listas (cupons, promoções): "" = todas; "exclusivas" = só as de algum tipo; um tipo = as que valem para ele. */
export function ofertaPassa(segmentosDaOferta, filtro) {
  const segs = limparTipos(segmentosDaOferta);
  if (!filtro) return true;
  if (filtro === "exclusivas") return segs.length > 0;
  return !segs.length || segs.includes(filtro);
}

/** Tipo vindo da URL (?para=recorrente) — o botão de ofertas da tela de Clientes. */
export const tipoDaUrl = (params) => {
  const t = params?.get?.("para");
  return t && TIPOS_CLIENTE[t] ? t : null;
};
